export default __webpack_public_path__ + "static/media/bylaws.01022701.png";